module.exports = __webpack_public_path__ + "static/Trims-a2b66633cbe38afb0ff1be82beebbca3.png";